import { useCallback } from "react";
import SearchActions from "../SearchActions";
import { Serializer } from "@shared/mirage/helpers/Serializer";
import { EntityTableStateStorage } from "@mirage/components/entityTable/EntityTableStateStorage";
import { useNavigate } from "react-router-dom";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";
import "./PropertySearch.css";
import { atom, useRecoilState } from "recoil";
import PublicPortalState from "@publicPortal/utils/InitialState";
import PropertySearchFields from "./PropertySearchFields";

const pp = new PublicPortalRoutingService();
const { initialSearchState } = PublicPortalState.propertySearch();
export const propertySearchState = atom({
    key: "propertySearchState",
    default: initialSearchState,
});

const PropertySearch = () => {
    const navigate = useNavigate();
    const [addressDetails, setAddressDetails] = useRecoilState<{ filter: PropertySearchFilter }>(propertySearchState);
    const setStateModifier = useCallback(
        (modifier: Partial<PropertySearchFilter>) => {
            setAddressDetails((prev) => {
                return { ...prev, filter: { ...prev.filter, ...modifier } };
            });
        },
        [setAddressDetails]
    );

    return (
        <>
            <PropertySearchFields state={addressDetails.filter} setStateModifier={setStateModifier} />
            <SearchActions onCancelHandler={onClear} onSubmitHandler={onSubmit} />
        </>
    );

    function onClear() {
        setAddressDetails(initialSearchState);
    }

    function onSubmit() {
        const filter = { uprn: addressDetails.filter.uprn };
        const searchParams = Serializer.toQueryParamsNotEmptyOnly(filter);
        EntityTableStateStorage.clear("propertySearch");
        navigate(`${pp.SearchRoute("PropertySearch", searchParams)}`);
    }
};

export default PropertySearch;
